import api from '@/api/client'
import { fetchAllPages } from './pagination'

/**
 * Courses service
 */

/**
 * Fetch CMS courses list.
 * @param {Record<string, any>} params
 */
export const fetchCmsCourses = async (params = {}) => {
  return fetchAllPages('cms/courses/', params)
}

/** Fetch exactly one catalog page; preserve totals and navigation metadata. */
export const fetchCmsCoursePage = async (params = {}) => {
  const { data } = await api.get('cms/courses/', { params })
  if (!data || !Array.isArray(data.results) || !Number.isSafeInteger(data.count) || data.count < 0) {
    throw new Error('Invalid course catalog response. Please try again.')
  }
  return { results: data.results, count: data.count, next: data.next, previous: data.previous }
}

/**
 * Fetch CMS course detail by CMS course id.
 * @param {number|string} cmsCourseId
 */
export const fetchCmsCourseDetail = async (cmsCourseId) => {
  const res = await api.get(`cms/courses/${cmsCourseId}/`)
  return res.data
}

export const fetchCmsCourseCategories = async () => {
  return fetchAllPages('cms/categories/')
}

export const fetchCmsCollections = async (params = {}) => {
  return fetchAllPages('cms/collections/', params)
}

export const fetchLearningPaths = async () => {
  return fetchAllPages('cms/learning-paths/')
}

export const fetchLearningPath = async slug => {
  const { data } = await api.get(`cms/learning-paths/${encodeURIComponent(slug)}/`)
  return data
}

export const createCmsCollection = async (payload) => {
  const res = await api.post('cms/collections/', payload)
  return res.data
}

export const updateCmsCollection = async (collectionIdOrSlug, payload) => {
  const res = await api.patch(`cms/collections/${encodeURIComponent(collectionIdOrSlug)}/`, payload)
  return res.data
}

export const deleteCmsCollection = async (collectionIdOrSlug) => {
  const res = await api.delete(`cms/collections/${encodeURIComponent(collectionIdOrSlug)}/`)
  return res.data
}

/**
 * Resolve DRF course by CMS id.
 * @param {number|string} cmsCourseId
 */
export const fetchDrfCourseByCmsId = async (cmsCourseId) => {
  const res = await api.get(`courses/by-cms/${cmsCourseId}/`)
  return res.data
}

/**
 * Check access info for a DRF course id.
 * @param {number|string} drfCourseId
 */
export const checkCourseAccess = async (drfCourseId) => {
  const res = await api.get('check-access/', { params: { course_id: drfCourseId } })
  return res.data
}

export const importCourseFile = async (file, username = '') => {
  const form = new FormData()
  form.append('markdown', file)
  if (username && username.trim()) form.append('username', username.trim())
  const res = await api.post('cms/import-course/', form, { headers: { 'Content-Type': 'multipart/form-data' } })
  return res.data
}

export const importCourseContent = async (content, username = '') => {
  const payload = { content }
  if (username && username.trim()) payload.username = username.trim()
  const res = await api.post('cms/import-course/', payload)
  return res.data
}

export const generateCourseOutline = async form => {
  const { data } = await api.post('cms/course-generation/outline/', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}

export const generateCourseDraft = async (outlineToken, outline) => {
  const { data } = await api.post('cms/course-generation/draft/', {
    outline_token: outlineToken,
    outline,
  })
  return data
}
